import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as html2pdf from 'html2pdf.js';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { PaymentHistoryService } from '../payment-history.service';


@Component({
  selector: 'app-transactional-data',
  templateUrl: './transactional-data.component.html',
  styleUrls: ['./transactional-data.component.scss']
})
export class TransactionalDataComponent implements OnInit {
  transactionalDetails: any = [];
  isPDF: boolean;
  paymentHistoryDetails: any;
  userInfo: any;
  userId;
  transactionalDataSubscription: any;
  baseSiteId: string;
  isAsmUser: boolean = false;
  firewallExempt: boolean = false;
  csAgentAuthSubscription: Subscription;
  transactionalFullDetails: any;
  constructor(
    private service: PaymentHistoryService,
    private readonly cdr: ChangeDetectorRef,
    private router: Router,
    private readonly cd: ChangeDetectorRef,
    private readonly user: UserAccountFacade,
    private readonly csAgentAuthService: CsAgentAuthService,
    private baseSiteService: BaseSiteService,
    private readonly sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    // this.firewallExempt = this.sharedService.getSessionStorage('firewallExempt');
    this.userInfo = this.user.get().subscribe((userData) => {
      this.userId = userData;
      this.transactionalFullDetails = JSON.parse(localStorage.getItem('transactionalData'));
      this.paymentHistoryDetails = this.transactionalFullDetails?.details;
      if (this.paymentHistoryDetails[0]?.type === 'legacy') {
        const params = { userId: this.userId?.uid }
        const filters = { clearDocNumber: this.paymentHistoryDetails[0]?.clearingDocNo, invoiceNumber: this.paymentHistoryDetails[0]?.invoiceNo }
        //this.service.getTransactionalDetails(params,filters);
        this.transactionalDataSubscription = this.service.getTransactionalDetails(params, filters).subscribe((res) => {
          if (res !== null) {
            this.transactionalFullDetails = res;
            this.transactionalDetails = res?.paymentHistories;
            this.transactionalDetails.forEach((item) => {
              item['type'] = 'legacy'
            });
            this.cd.detectChanges();
          }
        });
      }
      else {
        this.transactionalDetails = this.paymentHistoryDetails
        this.cd.detectChanges();
      }
    })
  }

  ngOnDestroy() {
    localStorage.removeItem('transactionalData');
    if (this.paymentHistoryDetails[0]?.type === 'legacy') {
      this.transactionalDataSubscription?.unsubscribe();
    }
  }

  goToPaymentHistory() {
    this.router.navigate(['/my-account/paymenthistory']);
  }

  exportXls() {
    let transactionalDetails = [];
    for (let item of this.transactionalDetails) {
      transactionalDetails.push({
        'Due Date': item.dueDate,
        'Date paid': item.paymentDate,
        'Invoice #': item.invoiceNo,
        'PO #': item.poNo,
        'Invoice amount': item.invoiceAmount,
        'Prompt pay discount': item.discountAmount,
        'Amount paid': item.plannedAmount,
        'Payment method': item.paymentMethod == 'Pay by credit' ? `${item.paymentMethod} ${item.clearDocRef}` : item.paymentMethod,
        'Invoice balance': item.invoiceBalance
      });
    }
    this.service.downloadXls(transactionalDetails, 'TransactionalData');
  }

  generatePDF() {
    this.cd.detectChanges();
    const options = {
      margin: [15, 5, 15, 5],
      filename: 'Transactional data.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        scale: 1,
        letterRendering: true,
      },
      pagebreak: { mode: 'css' },
      jsPDF: { orientation: 'p', format: 'a4', unit: 'pt' },
    };
    const element = document.getElementById('transactional-data-page');
    html2pdf().from(element).set(options).save();
  }

  pdfOpen(data): void {
    if (data.type == 'legacy') {
      this.service.getInvoicepdf(data.encryptedInvoiceNumber);
    } else {
      this.service.downloadPdf(data.encryptedInvoiceNumber);
    }
  }

  asmStringCheck(invoiceNumber) {
    let val = (/^\d+$/).test(invoiceNumber);
    return (!val || invoiceNumber.length >= 11 || invoiceNumber.length <= 7 ||
      (this.isAsmUser && this.transactionalFullDetails?.isComServeAgent));
  }
}
